(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4141,5945],{

/***/ 34233:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/play",
      function () {
        return __webpack_require__(54581);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1425,496,741,2127,4448,1385,8368,6538,6117,9721,1289,4157,1743,4581,9774,2888,179], function() { return __webpack_exec__(34233); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);